import Connection from 'general-mqtt'
import CryptoJS from 'crypto-js'
import platform from 'platform'
import VConsole from 'vconsole'

import fixed1Icon from '@/assets/images/fixed-1.png' // 固定工位：已分配
import fixed2Icon from '@/assets/images/fixed-2.png' // 固定工位：未分配
import ellipse1Icon from '@/assets/images/bubble-1.png' // 气泡空闲状态
import ellipse2Icon from '@/assets/images/bubble-3.png' // 气泡部分空闲
import ellipse3Icon from '@/assets/images/bubble-2.png' // 气泡约满
import ellipse4Icon from '@/assets/images/bubble-4.png' // 气泡不可用
import circle1Icon from '@/assets/images/circle-1.png' // 圆空闲状态
import circle2Icon from '@/assets/images/circle-3.png' // 圆部分空闲
import circle3Icon from '@/assets/images/circle-2.png' // 圆约满
import circle4Icon from '@/assets/images/circle-4.png' // 圆不可用
import square1Icon from '@/assets/images/square-1.png' // 正方形空闲状态
import square2Icon from '@/assets/images/square-3.png' // 正方形部分空闲
import square3Icon from '@/assets/images/square-2.png' // 正方形约满
import square4Icon from '@/assets/images/square-4.png' // 正方形不可用
import fixedIcon from '@/assets/images/fixed.png' // 固定工位
import notFull from '@/assets/images/add-outsider.png'
import JSEncrypt from 'jsencrypt'

const MAKE_LEISURE = 'MAKE_LEISURE' // 空闲
const MAKE_FULL = 'MAKE_FULL' // 已预约
const MAKE_UNUSABLE = 'MAKE_UNUSABLE' // 不可用
const MAKE_NOT_FULL = 'MAKE_NOT_FULL' // 部分空闲
const stationIconTypeList = [
  {
    type: 'ellipse',
    list: [
      {
        status: MAKE_LEISURE, // 空闲
        url: ellipse1Icon,
      },
      {
        status: MAKE_NOT_FULL, // 部分空闲
        url: ellipse2Icon,
      },
      {
        status: MAKE_FULL, // 约满
        url: ellipse3Icon,
      },
      {
        status: MAKE_UNUSABLE, // 不可用
        url: ellipse4Icon,
      },
    ],
  },
  {
    type: 'circle',
    list: [
      {
        status: MAKE_LEISURE,
        url: circle1Icon,
      },
      {
        status: MAKE_NOT_FULL, // 部分空闲
        url: circle2Icon,
      },
      {
        status: MAKE_FULL,
        url: circle3Icon,
      },
      {
        status: MAKE_UNUSABLE,
        url: circle4Icon,
      },
    ],
  },

  {
    type: 'square',
    list: [
      {
        status: MAKE_LEISURE,
        url: square1Icon,
      },
      {
        status: MAKE_NOT_FULL, // 部分空闲
        url: square2Icon,
      },
      {
        status: MAKE_FULL,
        url: square3Icon,
      },
      {
        status: MAKE_UNUSABLE,
        url: square4Icon,
      },
    ],
  },
  {
    type: 'fixed',
    list: [
      {
        status: MAKE_LEISURE,
        url: fixedIcon,
      },
      {
        status: MAKE_NOT_FULL,
        url: fixedIcon,
      },
      {
        status: MAKE_FULL,
        url: fixedIcon,
      },
      {
        status: MAKE_UNUSABLE,
        url: fixedIcon,
      },
    ],
  },
]

/**
 * 从主机配置中获取 totalInfo
 *  {
 *    groups: totalInfo.DEVICE_GROUP && totalInfo.DEVICE_GROUP.dataArray,
 *    devices: totalInfo.DEVICE && totalInfo.DEVICE.data,
 *    scenes: totalInfo.PATTERN && totalInfo.PATTERN.dataArray
 *  }
 *
 * @param {*} config
 */
export const getTotalInfoFromHomeConfig = config => {
  let groups = []
  let devices = []
  let scenes = []

  if (config) {
    const { DEVICE_GROUP, PATTERN } = config
    if (PATTERN && PATTERN.length) {
      scenes = PATTERN // 全局场景
    }
    if (DEVICE_GROUP) {
      DEVICE_GROUP.forEach(group => {
        devices = devices.concat(group.DEVICE)
        scenes = scenes.concat(group.PATTERN)
        delete group.DEVICE
        delete group.PATTERN
        groups.push(group)
      })
    }
  }

  return {
    groups,
    devices,
    scenes,
  }
}

export function arrayUnique(arr) {
  let res = [],
    obj = {}
  for (let i = 0; i < arr.length; i++) {
    if (!obj[arr[i]]) {
      res.push(arr[i])
      obj[arr[i]] = 1
    } else {
      obj[arr[i]]++
    }
  }
  return res
}

export const initMqttConnection = ({ userId, onConnected }) => {
  // 阿里云 mqtt 连接参数
  // const uri = 'wss://mqtt.cn-beijing.aliyuncs.com/mqtt'
  // const userName = 'nOBS5AqkLPXj5QUc'
  // const password = 'nVA2aIN8amKyN8QGYNBSQxMqu58='
  // const clientId = `GID_newbest@@@${serialNum}`

  // 自建立 mqtt 连接参数
  const uri = 'wss://mqtt.newbest.com.cn/mqtt'
  const userName = 'newbest'
  const password = 'NewBestMqtt.'
  const clientId = `newseed_h5_${userId}`

  const mqttConnection = new Connection({
    uri,
    clientId,
    env: 'web',
  })

  mqttConnection.onConnected = onConnected

  mqttConnection.traceFunction = data => console.log('MQTT', data)

  mqttConnection.connect({
    userName,
    password,
    reconnect: true,
    timeout: 5,
    cleanSession: true,
    maxReconnectTimeInterval: 32,
    onFailure: err => {
      console.log('MQTT', 'connect onFailure: ', err)
    },
  })

  window.mqttClient = mqttConnection
}

export function getQueryStringArgs() {
  var qs = location.search.length > 0 ? location.search.substring(1) : ''
  var args = {}
  // 取得每一项
  var items = qs.length > 0 ? qs.split('&') : []
  var length = items.length
  for (var i = 0; i < length; i++) {
    var item = items[i].split('=')
    var name = decodeURIComponent(item[0])
    var value = decodeURIComponent(item[1])
    if (name.length > 0) {
      args[name] = value
    }
  }
  return args
}

export const getCommandTopic = serialNum => `newbest/temi/${serialNum}/`
export const getAPITopic = serialNum => `newbest/temi/${serialNum}/api/`

/**
 * 元素坐标转换 'x:12,y:33'=>{x:12,y:33}
 * @param str
 * @returns
 */
export const transformStationXY = str => {
  const arr = str ? str.split(',') : []
  if (arr.length < 2) {
    return {
      x: 0,
      y: 0,
    }
  }
  return {
    x: Number(arr[0].split(':')[1]),
    y: Number(arr[1].split(':')[1]),
  }
}

/**
 * 根据工位的形状和工位状态更新工位图颜色
 * @param type 工位的形状 'ellipse' | 'circle' | 'square'
 * @param status 工位预约状态 MAKE_LEISURE：空闲；MAKE_RESERVED：已预约；MAKE_UNUSABLE：不可用
 * @returns
 */
export const getStatusIconUrl = (type, status, element) => {
  if (type === 'fixed') {
    return element?.userName ? fixed1Icon : fixed2Icon
  }
  const item = stationIconTypeList.find(v => v.type === type)
  let url = ''
  if (item?.list && item.list.length > 0) {
    url = item?.list.find(v => v.status === status)?.url
  }
  return url
}

/**
 * web 配置的工位图尺寸1040*640，移动端显示工位图的尺寸260*160，缩放比例 1040/260 = 4，同比缩小
 * @param {*} value
 * @returns
 */
export const getWorkAreaStationScale = (value, num) => {
  if (!value) {
    return 0
  }
  return Number((value / (num ? num : 4)).toFixed(3))
}

export const arrDuplication = arr => {
  let obj = {} //有助于增加遍历效率
  arr = arr.reduce((cur, next) => {
    obj[next.value] ? '' : (obj[next.value] = true && cur.push(next))
    return cur
  }, [])
  return arr
}

/**
 * 数组对象去重
 * @param arr
 * @param uniId
 * @returns
 */
export const uniqueFunc = (arr, uniId) => {
  const res = new Map()
  return arr.filter(item => !res.has(item[uniId]) && res.set(item[uniId], 1))
}

/**
 * 将组织架构员工转为一维数组（可能会有重复，使用需要去重）
 * @param arr
 * @param uniId
 * @returns
 */
export const flatOrganization = arr => {
  let list = []
  arr.forEach(element => {
    if (element.staffs && element.staffs.length > 0) {
      list = [...list, ...element.staffs]
    }
    if (element.children && element.children.length > 0) {
      list = [...list, ...flatOrganization(element.children)]
    }
  })
  return list
}

export const getWebSocketOrigin = () => {
  return process.env.VUE_APP_IF_INSIDE
    ? `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`
    : process.env.VUE_APP_WEBSOCKET_URL
}

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word, keyWord = 'XwKsGlMcdPMEhR1B') {
  var key = CryptoJS.enc.Utf8.parse(keyWord)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

/*判断客户端类型*/
export const checkPlatform = () => {
  if (platform.os.family === 'Android') {
    return 'Android'
  } else if ((platform.os.family === 'iOS') | (platform.os.family === 'OS X')) {
    // ios和mac
    return 'IOS'
  } else {
    return 'PC'
  }
}

// 根据客户端进行日期处理new Date() 方法。ios不支持2021-01-03这种格式，需要将“-”换为“/”。Android不需要处理。
export const fixNewDate = old => {
  let date = old
  if (checkPlatform() === 'IOS') {
    date = old.replace(/-/g, '/')
  }
  return date
}

// 用户密码校验规则
export const verifyPassword = password => {
  // 满足规则：密码修改要求必须包含数字、⼤写字母、⼩写字母、特殊字字符4种中⾄少3种，且不少于8位

  // 满足规则1：密码修改要求必须包含数字、⼤写字母、⼩写字母、特殊字字符4种中⾄少3种
  const rexg1 =
    /(?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*\W)|(?=.*\d)(?=.*[a-z])(?=.*\W)|(?=.*[A-Z])(?=.*[a-z])(?=.*\W)/
  // 满足规则2:密码长度不少于8位
  const rexg2 = /.{8,}/
  return rexg1.test(password) && rexg2.test(password)
}

const widhtDesign = 1920 // 设计稿宽
const screenWidth = document.body.clientWidth
export const screenHeight = document.body.clientHeight

/**
 * 用于ecahrts里的字体px转换适配
 * @param size
 * @returns
 */
export const scaleSize = size => {
  return `${(screenWidth * size) / widhtDesign}px`
}

const PUBLIC_KEY =
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkudwb9Rioa1A53PDOlJ7EXiPwD1PlEePiLnB3GHyi/hJ2x8rnI+L2kkkRQbmfsujMuZpYvGX/swYLfQNW3UgtDOicgVyEb+d2Gxgpuu5gy2J9q2K70YMVzKF7/VV7yFR2mRJ5BTqz++zjJWxElHr3lwg5DBMO0kuM3Ns54d3zDvykOWkSS1HM+yrthKD2YxwdSTEhMPlD8fIA50/iYzVArEFWmzgx3sixhfIDISBsCkQStLd4bP5Rw9GOvrZkgX0BTn006vQOtBhXO+Dn0LjM/zNuKzhqW19VcHjxvwbUOxYJnxbVl2/zbYKtFfkea7czuFmp7Q/n8elG6p5z0h07wIDAQAB'

export const rsa = msg => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(PUBLIC_KEY) //设置公钥
  return encryptor.encrypt(msg)
}

export const groupById = (arr, id) => {
  if (arr.length === 0) {
    return []
  }
  let map = {}
  for (let i = 0; i < arr.length; i++) {
    let ai = arr[i]
    if (!map[id]) {
      map[id] = [ai]
    } else {
      map[id].push(ai)
    }
  }
  let res = []
  Object.keys(map).forEach(key => {
    res.push({
      id: map[key]?.[0]?.[id],
      data: map[key],
    })
  })
  return res
}

// 是否在企业微信环境
export const isQiWeiPlatform = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork') {
    return true
  } else {
    return false
  }
}

// 是否在飞书环境
export const isFeiShuPlatform = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/lark/i) == 'lark') {
    return true
  } else {
    return false
  }
}

// 是否在newwork app环境
export const isNewworkAPPPlatform = () => {
  return window?.injectData?.source === 'NewWorkAPP'
}

export const toggleVConsole = () => {
  if (window.vConsole) {
    window.vConsole.destroy()
    window.vConsole = null
  } else {
    window.vConsole = new VConsole()
  }
}
